import * as $ from 'jquery';
import 'slick-carousel';
import { querySelectorAll } from '../functions/querySelectors';
import checkNextPrevSlider from '../functions/checkNextPrevSlider';

const SLIDER_CLASS = 'js-article-slider';
const SLIDER_IN_CLASS = 'js-article-slider--images';
const SLIDER_INIT_CLASS = 'jas-init';
const PREV_CLASS = 'c-articles-slider__nav-item--prev';
const NEXT_CLASS = 'c-articles-slider__nav-item--next';
const FULLSIZE_CLASS = 'c-theme-writing--fullsize';
const OPTIONS_1 = {
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  mobileFirst: true,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 3
      }
    }
  ]
};

const OPTIONS_2 = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    }
  ]
};

const OPTIONS_3 = {
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6
      }
    }
  ]
};

let initSlider = function(element, options) {
  let $element = $(element);

  $element.on('init', checkNextPrevSlider);
  $element.on('afterChange', checkNextPrevSlider);

  options.nextArrow = $element.parent().find(`.${NEXT_CLASS}`);
  options.prevArrow = $element.parent().find(`.${PREV_CLASS}`);

  $element.slick(options);
};

export function sliderBlog() {
  // tema varianta
  let fullsizeElements = querySelectorAll(`.${FULLSIZE_CLASS} .${SLIDER_CLASS}:not(.${SLIDER_INIT_CLASS})`);

  fullsizeElements.forEach((element) => {
    element.classList.add(SLIDER_INIT_CLASS);
    initSlider(element, OPTIONS_3);
  });

  // tema varianta
  let elements = querySelectorAll(`.${SLIDER_CLASS}:not(.${SLIDER_INIT_CLASS})`);

  elements.forEach((element) => {
    element.classList.add(SLIDER_INIT_CLASS);
    initSlider(element, OPTIONS_1);
  });

  // varianta uvnitr clanku
  let elements2 = querySelectorAll(`.${SLIDER_IN_CLASS}:not(.${SLIDER_INIT_CLASS})`);

  elements2.forEach((element) => {
    element.classList.add(SLIDER_INIT_CLASS);
    initSlider(element, OPTIONS_2);
  });
}
